'use client';

import dynamic from 'next/dynamic';

const TradeInSearchCar = dynamic(() => import('./TradeInSearchCar').then((mod) => mod.TradeInSearchCar));

export const TradeInSearchCarDynamic = TradeInSearchCar;
